import type {ReactElement} from 'react';
import React from 'react';
import type { PosterEditorProps} from '@Components/poster-editor';
import {PosterEditor} from '@Components/poster-editor';
import styles from './poster-editor-page.module.scss';

type PosterEditorPageProps = PosterEditorProps;

export function PosterEditorPage({...props}: PosterEditorPageProps): ReactElement<any> | null {
  return (
    <div className={styles.container}>
      <PosterEditor {...props} />
    </div>
  );
}
